<template>
  <div>

    <div>

      <category-filter :tca="tca" :tsa="tsa" :showFilters="this.showFilters" v-if="this.showFilters"></category-filter>

      <category-quickview v-if="this.showQuickView" :item="this.item" ></category-quickview>

      <div class="relative grid">
        <div class="w-fit px-s5 absolute left-0 top-[75px] m_376:px-s10 m_426:px-s20 m_650:px-0 m_650:top-s20">
          <ul class="breadcrumbs flex flex-wrap items-start justify-items-start text-t14 m_1200:text-t16">
            <li><a :href="getBaseUrl">Home</a></li>
            <li v-for="(item) in getRestOfBreadcrums()"><span class="text-gold mx-s5">/</span><a :href="item.path">{{ item.title }} </a></li>
          </ul>

          <h1 class="text-t22 m_376:text-t26 m_800:text-t30 uppercase">{{ getLastBreadcrumb().title }}</h1>
        </div>

        <category-select></category-select>

        <div v-if="loader === false"
          class="mx-auto mt-s80 pb-s20 max-w-s800 grid grid-cols-2 gap-x-s20 gap-y-s40 m_376:mt-[85px] m_650:mt-0 m_650:grid-cols-3 m_800:gap-x-s40 m_1000:max-w-full m_1000:grid-cols-4 m_1000:gap-x-0 m_1300:grid-cols-5">
          <template v-for="(product, index) in products.data">
            <div v-if="bannerImages.length > 0 && index === 18" v-bind:key="index" class="col-span-2 m_580:col-auto">
              <category-banner></category-banner>
              <category-banner-mobile></category-banner-mobile>
            </div>
            <template v-if="mobile == 1">
              <category-product-mobile :item="product" :index="index">
              </category-product-mobile>
            </template>
            <template v-else>
              <category-product :item="product" :index="index">
              </category-product>
            </template>
          </template>
        </div>
      </div>

    </div>

    <div class="min-h-s400 m_1000:hidden" v-if="loader === true"></div>

    <category-loader v-if="loader === true"></category-loader>

    <vue-pagination v-if="products.last_page > 1" :key="$route.path" :pagination="products" @paginate="getProducts()"
      :offset="2">
    </vue-pagination>

  </div>
</template>

<script>

export default {
  name: "CategoryProducts",

  data() {
    return {
      products: this.$attrs.products,
      properties: this.$attrs.properties,
      sortType: 'publish_at',
      sortValue: 'desc',
      selectedFilters: this.$attrs.selectedfilters,
      selectedBrends: this.$attrs.selectedbrends,
      showQuickView: false,
      showFilters: false,
      item: {},
      breadcrumbs: this.$attrs.breadcrumbs,
      //maxPrice: this.$attrs.max,
      mobile: this.$attrs.mobile,
      bannerImages: this.$attrs.bannerimages,
      tsa: this.$attrs.tsa,
      tca: this.$attrs.tca,
      loader: false
    }
  },

  mounted() {
    this.hideCategoryLoader();
  },

  computed: {
    /**
     * Return base url of site.
     *
     * @returns {string}
     */
    getBaseUrl() {
      return window.location.origin;
    }
  },

  methods: {
    hideCategoryLoader() {
      document.getElementById("category_loader").style.display = "none";
    },

    getProducts() {

			this.loader = true;
      let selectedFiltersIds = this.selectedFilters.map(item => item.id);
      let selectedBrendsIds = this.selectedBrends.map(item => item.id);

      let selectedFiltersForUrl = selectedFiltersIds.join('&filters[]=');
      let selectedBrendsForUrl = selectedBrendsIds.join('&brends[]=');

      let sortType = this.sortType;
      let sortValue = this.sortValue;

      var realPath = (selectedBrendsIds.length > 0 ? `brends[]=${selectedBrendsForUrl}` : "") +
        (selectedFiltersIds.length > 0 ? `&filters[]=${selectedFiltersForUrl}` : "") +
        `&sortType=${sortType}` +
        `&sortValue=${sortValue}` +
        `&page=${this.products.current_page}`;

      axios.get(`${this.$attrs.url}?${realPath}`)
        .then((response) => {

          this.products = response.data.products;
					this.loader = false;
          this.$router.push(`?${realPath}`);
        })
        .catch((e) => {
          console.log('handle server error from here', e);
        });
    },

    getLastBreadcrumb() {
      let breadcrumb = this.breadcrumbs.slice(-1).pop();

      return breadcrumb;
    },

    getRestOfBreadcrums() {
      let breadcrumbs = this.breadcrumbs.slice(0, -1);

      return breadcrumbs;
    }

  },
}
</script>
